import { render, staticRenderFns } from "./popupAddArticle.vue?vue&type=template&id=6b4399b3&scoped=true&lang=pug"
import script from "./popupAddArticle.vue?vue&type=script&lang=js"
export * from "./popupAddArticle.vue?vue&type=script&lang=js"
import style0 from "../../assets/koromo_min.css?vue&type=style&index=0&id=6b4399b3&prod&scoped=true&lang=css&external"
import style1 from "./popupAddArticle.vue.css?vue&type=style&index=1&id=6b4399b3&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4399b3",
  null
  
)

export default component.exports